// src/features/resources/format.ts
// Pure formatting/error helpers for the resource feature — no React imports.

export function errMessage(e: unknown, fallback: string): string {
  if (e instanceof Error && e.message) return e.message;
  return fallback;
}

export function fmtDateTime(value: string | undefined, locale = 'en'): string {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString(locale, {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return value;
  }
}
